import styled from 'styled-components';

import { PRESCRIPTION_ISSUING_PANELS_GAP } from './prescriptionIssuingPanel.constants';

const StyledPrescriptionIssuingPanel = styled.div`
   display: flex;
   flex-direction: row;
   flex: 1;
   gap: ${PRESCRIPTION_ISSUING_PANELS_GAP};
   min-height: 0;
`;

StyledPrescriptionIssuingPanel.displayName = 'StyledPrescriptionIssuingPanel';

export { StyledPrescriptionIssuingPanel };
